module.exports = __webpack_public_path__ + "img/enna.e22555e5.png";